import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Organization } from "../../../services/organization/organizationModel";
import {
  PremiumSponsorship,
  PremiumSponsorshipStatus,
} from "../../../services/premiumSponsorship/premiumSponsorshipModel";
import { countAvailableSponsorshipCredits } from "../../../services/premiumSponsorship/premiumSponsorshipService";

const PremiumSponsorshipsOverview = ({
  organization,
  sponsorships,
  onInvite,
}: {
  organization: Organization;
  sponsorships: PremiumSponsorship[];
  onInvite: () => void;
}) => {
  const { t } = useTranslation(["organization"]);

  const counts = useMemo(
    () =>
      sponsorships.reduce(
        (acc, sponsorship) => {
          acc[sponsorship.status] += 1;
          return acc;
        },
        {
          invited: 0,
          accepted: 0,
          declined: 0,
          revoked: 0,
        } as Record<PremiumSponsorshipStatus, number>,
      ),
    [sponsorships],
  );

  const availableCredits = useMemo(
    () => countAvailableSponsorshipCredits(organization, sponsorships),
    [organization, sponsorships],
  );

  return (
    <div className="overview-cards">
      <div className="category-card --primary --txt--center">
        <div>{t("organization:premium-sponsorship.CREDITS_LEFT")}</div>
        <div className="count">{availableCredits}</div>
        <div>
          <button className="btn--white" onClick={onInvite}>
            {t("organization:premium-sponsorship.INVITE_BUTTON")}
          </button>
        </div>
      </div>

      <div className="category-card">
        <div>{t("organization:premium-sponsorship.overview.ACCEPTED")}</div>
        <div className="count">{counts.accepted}</div>
      </div>
      <div className="category-card">
        <div>{t("organization:premium-sponsorship.overview.DECLINED")}</div>
        <div className="count">{counts.declined}</div>
      </div>
      <div className="category-card">
        <div>{t("organization:premium-sponsorship.overview.INVITED")}</div>
        <div className="count">{counts.invited}</div>
      </div>
      <div className="category-card --highlight">
        <div>{t("organization:premium-sponsorship.overview.REVOKED")}</div>
        <div className="count">{counts.revoked}</div>
      </div>
    </div>
  );
};

export default PremiumSponsorshipsOverview;
